function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.CloseCircleFill", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["CloseCircleFill"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var CloseCircleFill = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM9.87862 8.46452L11.9999 10.5858L14.1213 8.4644C14.5118 8.07388 15.1449 8.07388 15.5355 8.4644C15.926 8.85493 15.926 9.48809 15.5355 9.87862L13.4141 12L15.5355 14.1214C15.926 14.5119 15.926 15.1451 15.5355 15.5356C15.1449 15.9261 14.5118 15.9261 14.1213 15.5356L11.9999 13.4142L9.87862 15.5355C9.48809 15.926 8.85493 15.926 8.4644 15.5355C8.07388 15.1449 8.07388 14.5118 8.4644 14.1213L10.5857 12L8.4644 9.87873C8.07388 9.48821 8.07388 8.85504 8.4644 8.46452C8.85493 8.07399 9.48809 8.07399 9.87862 8.46452Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = CloseCircleFill;
});